import React, { useContext } from "react";
import Search from "../../views/Library/Search/Search";
import UserAssignmentContext from "../../context/UserAssignmentContext";
import { useLibrarySearch } from "../../hooks/learningCenter/librarySearch";
import { useCourseUserAssignments } from "../../hooks/learningCenter/courseUserAssignments";
import { isIlt } from "../../utils/course_utils";

function LearningCenterLibrarySearch() {
  const { createUserAssignments } = useLibrarySearch();

  const { fetchCourseUserAssignment } = useCourseUserAssignments();
  const {
    onResumeAssignment,
    onStartAssignment,
    onChangeEnrollment
  } = useContext(UserAssignmentContext);

  const handleAddToMyCourses = trainingObjectIds =>
    createUserAssignments(trainingObjectIds);

  function handleStartOrResumeClick(course) {
    const id = course.parentId ? course.parentId : course.id;
    fetchCourseUserAssignment(id, {
      include: ["versions", "enrolled_training_object"]
    }).then(userAssignment => {
      if (
        userAssignment.status == "In Progress" ||
        userAssignment.status == "Pending"
      ) {
        onResumeAssignment(userAssignment);
      } else if (
        !userAssignment.enrolledTrainingObjectId &&
        (isIlt(userAssignment) || userAssignment.versions?.length > 1)
      ) {
        onChangeEnrollment(userAssignment);
      } else {
        onStartAssignment(userAssignment);
      }
    });
  }

  return (
    <React.Fragment>
      <Search
        onAddToCourses={handleAddToMyCourses}
        onStartOrResumeClick={handleStartOrResumeClick}
      />
    </React.Fragment>
  );
}

export default LearningCenterLibrarySearch;
